const autoNgTemplateLoaderTemplate1 = require('./por-switch-field.html');

import angular from 'angular';

export const porSwitchField = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    tooltip: '@',
    ngModel: '=',
    label: '@',
    name: '@',
    labelClass: '@',
    ngDataCy: '@',
    disabled: '<',
    onChange: '<',
    feature: '<', // feature id
  },
};

angular.module('portainer.app').component('porSwitchField', porSwitchField);
